import React, { Component } from "react"
import { connect } from "react-redux"

import Colors from "../../../media/Colors"

import imageMan from "../../../media/images/man.png"

import imageWoman from "../../../media/images/woman.png"

import {Helmet} from "react-helmet";


// import detectSwipe from "../../../utils/detectSwipe"



import {
    handleRemoveFavoriteMedium,
    handleShowMediaModal,
    handleSetCurrentMedium,
    handleRemovePointOfInterest,
    handleSetCountry
} from "../../../actions/mediaAction"

import "./Map.css"

import {
    Grid,
    Header,
    Icon,
    Image,
    Menu,
    Segment,
    Sidebar,
    Checkbox,
    Button,
    Label,
    Loader,
    Dimmer,
    Responsive,
    Card,
    Ref,
    Select, 
    ButtonContent
} from "semantic-ui-react"

import 'react-toastify/dist/ReactToastify.css'

import MapContainer from "./MapContainer"
import FavoriteModal from "./MediaModal"
import ContactModal from "./ContactModal"
import SearchBox from "./SearchBox"
import HelpModal from "./HelpModal"
import LangButton from "./LangButton"

import { country_settings } from "../../../utils/country_settings"
import ReactCountryFlag from "react-country-flag"
import { countries } from "../../../utils/countries"
import { getFavoritesFromLocal, timeOutToRefresh } from "../../../utils/common"
import { withTranslation } from 'react-i18next';

class Main extends Component {

    constructor(props) {
        super(props)
        //debemos dejar el estado false solo en movil
        const { t } = this.props;
        this.state = {
            visible: (window.screen.availWidth < 500 ? false : true),
            typeFilter: {},
            selectAll: true,
            buttonSelectAll: t("main.deselect_all"),
            buttonGoToMap: "Ir al mapa",
            showSplashScreen: true,
            warningMessage: true,
            selectDigital: true,
            selectTraditional: true,
            country: props.match.params.country,
            settings: country_settings['MX']
        }

        this.showMenu = this.showMenu.bind(this)
        this.handleCheckboxFilter = this.handleCheckboxFilter.bind(this)
        this.getTypeFilter = this.getTypeFilter.bind(this)
        this.getFavorite = this.getFavorite.bind(this)
        this.getPointOfInterest = this.getPointOfInterest.bind(this)
        this.showFavotires = this.showFavotires.bind(this)
        this.selectAll = this.selectAll.bind(this)
        this.seletDigitalOrTraditional = this.seletDigitalOrTraditional.bind(this)
        this.hideMenu = this.hideMenu.bind(this)
        this.sideMenu = React.createRef()
        this.getCountryByLocation = this.getCountryByLocation.bind(this)
        this.setCountry = this.setCountry.bind(this)
        this.countryHasSettings = this.countryHasSettings.bind(this)
        this.updateMarkersAndCircles = this.updateMarkersAndCircles.bind(this)
        this.setFromStorage = this.setFromStorage(this)
    }

    setCountry(newCountry) {
        this.setState({
            country: newCountry,
            settings: country_settings[newCountry] ? country_settings[newCountry] : country_settings['MX']
        })
        this.props.dispatch(handleSetCountry(newCountry))
    }

    setFromStorage(){
        const stored = getFavoritesFromLocal();
        if(stored.length > 0){
            this.props.media.favoriteMediaList = stored;
        }
    }

    countryHasSettings(newCountry = null) {
        const currentCountry = newCountry ? newCountry : this.state.country
        return country_settings[currentCountry] ? true : false
    }

    componentDidMount() {
        timeOutToRefresh()

        if (this.state.country == undefined) {
            // this.setCountry('MX')
        }
        // detectSwipe('side_menu',this.hideMenu)
    }

    componentDidUpdate(previousProps, previousState) {
        if (previousState.country === undefined) {
            this.getCountryByLocation()
        }

    }


    getCountryByLocation () {
        const self = this

    }

    showMediaModal(medium) {
        this.props.dispatch(handleShowMediaModal(true))
        this.props.dispatch(handleSetCurrentMedium(medium))
    }

    showFavotires() {
        this.props.dispatch(handleShowMediaModal(true))
    }

    showMenu(e) {
        this.setState({
            visible: !this.state.visible,
        })
    }

    selectAll(e) {
        const { t } = this.props;
        const checked = !this.state.selectAll;
        const buttonSelectAll = checked ? t("main.deselect_all") : t("main.select_all");

        this.setState({ buttonSelectAll, selectAll: checked }, () => {
            const refs = Object.keys(this.refs);
            Promise.all(
                refs.map(ref =>
                    new Promise(resolve =>
                        this.refs[ref].setState({ checked }, resolve)
                    )
                )
            ).then(() => {
                this.updateMarkersAndCircles();
            });
        });
    }

    handleWhatsApp(e){
        const { t } = this.props;
        window.open(`https://wa.me/52${this.props.media.currentExecutive.officePhoneNumber}?text=${t("main.whastapp_text")}`, '_blank');
    }

    seletDigitalOrTraditional(e) {
        let digital = this.state.selectDigital
        let traditional = this.state.selectTraditional
        if (e == "traditional") {
            traditional = !traditional
            this.setState({
                selectTraditional: traditional
            })
            this.handleCheckboxFilter(e, {name: "traditional", checked: traditional})
        }
        if (e == "digital") {
            digital = !digital
            this.setState({
                selectDigital: digital
            })
            this.handleCheckboxFilter(e, {name: "digital", checked: digital})
        }
    }

    handleCheckboxFilter(e, { name, checked }) {

        if (!this.refs[name] && (name != 'traditional' && name != 'digital')) return;

        const refsToUpdate = [];

        if (name === "espectacular") {
            refsToUpdate.push("unipolar", "azotea", "piso");
        }
        
        Promise.all(
            refsToUpdate.map(ref =>
                new Promise(resolve => {
                    if(this.refs[ref]){
                        this.refs[ref].setState({ checked }, resolve)
                    }
                }
            )
        )

        ).then(() => {
            this.updateMarkersAndCircles();
        });
    }


    updateMarkersAndCircles() {
        if (this.props.media.markersList) {
            const checkedRefs = new Set(
                Object.keys(this.refs).filter(ref => this.refs[ref].state.checked)
            );

            const visiblePositionKeys = new Set()
            this.props.media.markersList.forEach(marker => {
                const title = String(marker.getTitle());
                const show = checkedRefs.has(title);
                marker.setVisible(show);
                if (show) {
                    const pos = marker.getPosition()
                    if (pos) visiblePositionKeys.add(`${pos.lat()}_${pos.lng()}`)
                }
            });

            this.props.media.mapCircleList.forEach(circle => {
                const key = circle._centerKey
                const visible = key ? visiblePositionKeys.has(key) : false
                circle.setVisible(visible);
            });

            this.props.media.markerClusterer.render();
        }
    }




    getTypeFilter(filter, index) {

        const maxLength = 29
        let id = filter.original
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
        let name = `${filter.name.substr(0, maxLength)}`
        if (name == "Valla") name = "Valla fija"
        // name += filter.name.length > maxLength ? "..." : ""
        let hidden = false

        if (
             id == "unipolar" ||
             id == "azotea" ||
             id == "piso" ||
             id == "vitral" ||
             id == "mampara" ||
             id == "cajero automatico" ||
             id == "pluma de estacionamiento" ||
             id == "pantalla electronica"
        ) hidden = true

        return (
            <Grid.Column
                hidden={hidden}
                className="filter-container"
                key={`filter_${index}`}
                style={{paddingLeft: '0.5em', paddingRight: '0.5em'}}
            >
                {/* <Form.Group controlId={id} key={`filter_${index}`}>
          <Form.Check type="checkbox" label={name} onChange={ this.handleCheckboxFilter } name={id} ref={id} data-type="type" defaultChecked={true}/>
        </Form.Group> */}
                <div style={{
                    padding: '5px',
                    background: Colors[id],
                    display: 'inline-block',
                    marginRight: '5px',
                    borderRadius: '3px'
                }}>
                </div>
                <Checkbox
                    className="checkbox-white-label"
                    key={`filter_${index}`}
                    title={filter.original}
                    label={name}
                    fitted={true}
                    onChange={ this.handleCheckboxFilter }
                    name={id}
                    ref={id}
                    data-type="type"
                    defaultChecked={true}
                />
            </Grid.Column>
        )
    }

    removeFavorite(medium) {
        this.props.dispatch(handleRemoveFavoriteMedium(medium))
    }

    removePointOfInterest(index) {
        let points = this.props.media.pointsOfInterest[index]
        points.forEach((marker) => {
            marker.setMap(null)
        })
        this.props.dispatch(handleRemovePointOfInterest(index))
    }

    getFavorite(medium, index) {
        return (
            <Grid.Row key={`favorite_${index}`}>
                <Grid.Column
                    width={12}
                    textAlign="center"
                    verticalAlign="middle"
                >
                    <Label
                        style={Colors.styleSecondary}
                        as="a"
                        onClick={this.showMediaModal.bind(this, medium)}
                    >
                        {medium.full_code}
                    </Label>
                </Grid.Column>
                <Grid.Column width={4} verticalAlign="middle">
                    <Button
                        basic
                        compact
                        color="grey"
                        size="mini"
                        inverted
                        icon="trash"
                        title="Eliminar favorito"
                        onClick={this.removeFavorite.bind(this, medium)}
                    />
                </Grid.Column>
            </Grid.Row>
        )
    }

    getPointOfInterest(name, index) {
        const maxLength = 21
        let nameSub = `${name.substr(0, maxLength)}`
        nameSub += name.length > maxLength ? "..." : ""
        let button = (
            <Button
                basic
                compact
                color="grey"
                size="mini"
                icon="trash"
                title="Eliminar punto de interes"
                inverted
                onClick={this.removePointOfInterest.bind(this, name)}
            />
        )
        let width = 12
        if (name === "Sin puntos de interes") {
            button = <></>
            width = 16
        }
        return (
            <Grid.Row key={`favorite_${index}`}>
                <Grid.Column
                    width={width}
                    textAlign="center"
                    verticalAlign="middle"
                >
                    <Label style={Colors.styleSecondary}>{nameSub}</Label>
                </Grid.Column>
                <Grid.Column width={4} verticalAlign="middle">
                    {button}
                </Grid.Column>
            </Grid.Row>
        )
    }

    hideMenu(el,d) {
        if (d == "l") {
            this.setState({visible: false})
        } else if (d == "u") {
            this.sideMenu.current.scrollIntoView(false)
        }
    }

    handleDismiss = () => {
        this.setState({ warningMessage: false })
    }

    render() {
        const { t } = this.props;

        let renderFilters = () => {
            let types = this.props.media.filters.type

            if (types) {

                let filteredTypes = types.filter(type => {
                    return (type.original !== 'Medallon' || window.screen.availWidth > 500);
                });

                return filteredTypes.map((type, index) => {
                    return this.getTypeFilter(type, index)
                })
            }
        }

        let renderFavorites = () => {
            let favoriteMediaList = this.props.media.favoriteMediaList
            if (favoriteMediaList)
                return favoriteMediaList.map((medium, index) => {
                    return this.getFavorite(medium, index)
                })
        }

        let renderPointsOfInterest = () => {
            const { t } = this.props
            let pointsOfInterest = this.props.media.pointsOfInterest
            if (pointsOfInterest) {
                const points = []
                let index = 0
                for (const name in pointsOfInterest) {
                    points.push(this.getPointOfInterest(name, index))
                    index++
                }
                if (index === 0)
                    points.push(
                        this.getPointOfInterest(t("main.no_points_of_interest"), index)
                    )
                return points.map((point) => point)
            }
        }

        return (
            <>
                <Helmet>
                    <title>{t('metas.title')}</title>
                    <meta name="description" content={t('metas.description')} />
                </Helmet>
            <div style={{ height: "100vh" }}>
                <Dimmer active={this.props.media.loading} page>
                    <Image src={this.state.settings.logo} size="medium" centered />
                    <h2>Empresa de medios exteriores con cobertura internacional </h2>
                    <Loader style={{marginTop: "200px"}} indeterminate>
                        {(() => {
                            const { loaded, total } = this.props.media.fetchProgress || {}
                            if (total > 1) return `${t("loading")} ${loaded}/${total}`
                            return t("loading")
                        })()}
                    </Loader>
                </Dimmer>
                <Ref innerRef={this.sideMenu}>
                <Sidebar.Pushable as={Segment} id="side_menu" style={{display: 'flex'}}>
                    <Sidebar
                        as={Menu}
                        animation={ window.screen.availWidth > 500 ? "push" : "overlay"}
                        direction="left"
                        vertical
                        visible={this.state.visible}
                        style={{background: window.screen.availWidth > 500 ? Colors.primary : Colors.primaryOp}}

                    >
                        <Menu.Item>
                            <Grid>
                                <Grid.Column width={16}>
                                    <Responsive maxWidth={499}>
                                        <Grid.Column  width={7} textAlign="right">
                                            <Button
                                                // basic
                                                textAlign="right"
                                                icon={{
                                                    name: this.state.visible ? "minus" : "bars",
                                                    size: "big",
                                                    style: Colors.styleSecondary
                                                }}
                                                style={{padding: "2px 0px 5px 0px", background: Colors.secondary }}
                                                onClick={this.showMenu}
                                            />
                                            <Label color="black" pointing='left'>{t("main.click_to_hide")}</Label>
                                        </Grid.Column>
                                    </Responsive>
                                    <Image src={this.state.settings.logo} size="small" centered />
                                    <Header style={{display: "none"}} as="h1" inverted size="tiny">Mapa Naranti: Encuentra medios exteriores en un clic.</Header>
                                </Grid.Column>
                            </Grid>
                        </Menu.Item>
                        <Menu.Item>
                            <Grid columns={1}>
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Icon name="filter" style={{color: Colors.secondary}}/>
                                        {t("main.media_type")}
                                    </Header>
                                </Grid.Column>
                                <Grid.Column
                                    className="filter-container"
                                >
                                    <Checkbox
                                        className="checkbox-white-label"
                                        title={t("main.static_ooh")}
                                        label={t("main.static_ooh")}
                                        onChange={ () => this.seletDigitalOrTraditional("traditional") }
                                        checked={this.state.selectTraditional}
                                    />
                                    <Checkbox
                                        className="checkbox-white-label"
                                        title={t("main.static_ooh")}
                                        label={t("main.digital_ooh")}
                                        onChange={ () => this.seletDigitalOrTraditional("digital") }
                                        checked={this.state.selectDigital}
                                    />
                                </Grid.Column>
                            </Grid>
                        </Menu.Item>
                        <Menu.Item>
                            <Grid>
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Icon name="search" style={{color: Colors.secondary}}/>
                                        {t("main.select_your_country")}
                                    </Header>
                                </Grid.Column>
                            </Grid>
                            <br />
                            <Select
                                fluid={true}
                                placeholder={t("main.country")}
                                options={Object.entries(countries).map(([index, country]) => ({key: index.toLowerCase(), value: index.toLowerCase(), text: country}))}
                                defaultValue={this.state.country}
                                onChange={(e, data) => {
                                    window.location.href = `/ooh/${data.value.toLowerCase()}/`
                                }}
                            />
                        </Menu.Item>
                        <Menu.Item>
                            <Grid>
                                {/* <Grid.Column width={16}>
                                    {
                                        this.state.warningMessage ?
                                            <Message
                                                warning
                                                onDismiss={this.handleDismiss}
                                                header='¡Busca primero tu ciudad y luego tus puntos de interés!'
                                            >
                                            </Message>
                                        :
                                            <></>
                                    }
                                </Grid.Column> */}
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Icon name="search" style={{color: Colors.secondary}}/>
                                        {t("main.search_your_state")}
                                    </Header>
                                </Grid.Column>
                            </Grid>
                            <br />
                            <SearchBox states="true" country={this.state.country} />
                        </Menu.Item>
                        <Menu.Item>
                            <Grid>
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Icon name="search" style={{color: Colors.secondary}}/>
                                        {t("main.search_your_city")}
                                    </Header>
                                    <SearchBox />
                                </Grid.Column>
                            </Grid>
                        </Menu.Item>
                        <Menu.Item>
                            <Grid>
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Icon name="search" style={{color: Colors.secondary}}/>
                                        {t("main.search_your_points_of_interest")}
                                    </Header>
                                    <SearchBox />
                                    <Header as="h4" inverted>
                                        <Label style={Colors.styleSecondary} size="tiny" basic horizontal>
                                            <Icon name="map marker alternate" />
                                            {Object.keys(this.props.media.pointsOfInterest).length}
                                        </Label>
                                        {t("main.points_of_interest")}
                                    </Header>
                                </Grid.Column>
                            </Grid>
                            <Grid centered className="favorites-section">
                                {renderPointsOfInterest()}
                            </Grid>
                        </Menu.Item>
                        <Menu.Item>
                            <Grid columns={1}>
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Icon name="filter" style={{color: Colors.secondary}}/>
                                        {t("main.media_format")}
                                    </Header>
                                </Grid.Column>
                                {renderFilters()}
                                <Grid.Column width={16} textAlign="center">
                                    <Button
                                        style={Colors.styleSecondary}
                                        size="tiny"
                                        compact
                                        inverted
                                        content={this.state.buttonSelectAll}
                                        onClick={this.selectAll}
                                    />
                                </Grid.Column>
                                {
                                    window.screen.availWidth <= 500 && (
                                        <Grid.Column width={16} textAlign="center">
                                            <Button
                                                style={Colors.styleSecondary}
                                                size="tiny"
                                                compact
                                                inverted
                                                content={this.state.buttonGoToMap}
                                                onClick={(e) => this.setState({visible: false}) }
                                            />
                                        </Grid.Column>
                                    )
                                }
                            </Grid>
                        </Menu.Item>
                        {/* <Menu.Item>
                            <Grid>
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Label color='orange' size="tiny" basic horizontal>
                                            <Icon name="shopping cart" />
                                            {this.props.media.favoriteMediaList.length}
                                        </Label>
                                        Carrito
                                    </Header>
                                </Grid.Column>
                            </Grid>
                            <Grid centered className="favorites-section">
                                {renderFavorites()}
                            </Grid>
                            <Grid centered>
                                <Grid.Row>
                                    <Grid.Column width={16} textAlign="center">
                                        {this.props.media.favoriteMediaList.length ? (
                                            <Button
                                                color="green"
                                                size="small"
                                                compact
                                                onClick={this.showFavotires}
                                                content="Cotizar"
                                            />
                                        ) : (
                                            <Label style={Colors.styleSecondary}>
                                                Sin elementos
                                            </Label>
                                        )}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Menu.Item> */}
                        <Menu.Item>
                            <Grid>
                                <Grid.Column width={16} textAlign="center">
                                    <Header as="h5" inverted>
                                        <Icon name="user" style={{color: Colors.secondary}}/>
                                        {t("main.contact")}
                                    </Header>
                                </Grid.Column>
                            </Grid>
                            <Grid centered>
                                <Grid.Row>
                                    <Grid.Column width={16} textAlign="center">
                                        <Card>
                                            <Card.Content>
                                                <Card.Header>
                                                    <Image avatar src={ this.props.media.currentExecutive.gender == "M" ? imageMan : imageWoman } />
                                                    {this.props.media.currentExecutive.name}
                                                </Card.Header>
                                                <Card.Meta>{t("main.sales_advisor")}</Card.Meta>
                                                <Card.Description>
                                                    <strong>{this.props.media.currentExecutive.phoneFormatted}</strong><br/><br/>
                                                    {/* <strong>{t("main.office")} {this.props.media.currentExecutive.officePhoneNumberFormatted}</strong><br/><br/> */}
                                                    <strong>{this.props.media.currentExecutive.email}</strong><br/><br/>
                                                    <Button
                                                        as='a'
                                                        circular
                                                        color='green'
                                                        size='mini'
                                                        icon={{name: 'whatsapp', size:'big'}}
                                                        target='_blank'
                                                        className="btn_form_wa_active"
                                                        href={`
                                                            https://wa.me/52${this.props.media.currentExecutive.officePhoneNumber}?text=${t("main.whastapp_text")}
                                                        `}
                                                    />
                                                </Card.Description>
                                            </Card.Content>
                                            <Card.Content extra>
                                                <div className="ui two buttons">
                                                <Button
                                                    as="a"
                                                    href={`tel:+52${this.props.media.currentExecutive.phone}`}
                                                    size="mini"
                                                    compact
                                                    // basic
                                                    style={Colors.stylePrimary}
                                                    content={t("main.call")}
                                                />
                                                </div>
                                            </Card.Content>
                                        </Card>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Menu.Item>
                    </Sidebar>
                    <Sidebar.Pusher style={{ paddingTop: "0px", background: Colors.secondary, display: 'flex', width: '100%' }}>
                        <Segment basic style={{display: 'flex', width: '100%', height: '100%', flexDirection: 'column'}}>
                            <Grid.Row style={{ paddingBottom: "0px", paddingLeft: "10px", paddingRight: '10px', display: 'flex' }}>
                                <div className="col-4">
                                    <Button
                                        // basic
                                        icon={{
                                            name: this.state.visible ? "minus" : "bars",
                                            size: "big",
                                            style: Colors.styleSecondary
                                        }}
                                        style={{padding: "2px 0px 5px 0px", background: Colors.secondary }}
                                        onClick={this.showMenu}
                                    />
                                    <Label hidden={!this.state.visible || window.screen.availWidth < 500} color="orange" pointing='left'>{t("main.click_to_hide")}</Label>
                                </div>
                                <div className="col-4">
                                    <Responsive minWidth={768}>
                                        <Header as="h4" inverted >
                                                <Grid.Row className="d-flex justify-content-center align-item-center">
                                                    <Header style={{margin: 0}} as="h5" inverted>
                                                        {t("main.find_available_billboards_in")}
                                                    </Header>
                                                </Grid.Row>
                                                <Grid.Row style={{display: 'flex', justifyContent: 'center'}}>
                                                        <Select
                                                            fluid={true}
                                                            placeholder={t("main.select_your_country")}
                                                            style={{
                                                                textAlign: 'center',
                                                                margin: '10px',
                                                                fontSize:'17px',
                                                                borderRadius:'0'
                                                            }}
                                                            options={
                                                                Object.entries(countries).map(([index, country]) => ({
                                                                    key: index.toLowerCase(),
                                                                    value: index.toLowerCase(),
                                                                    text: <>
                                                                        <ReactCountryFlag
                                                                            countryCode={index}
                                                                            svg
                                                                            title={country}
                                                                            style={{justifyContent:'center' , alignItems:'center', fontSize:'18px'}}
                                                                        />
                                                                        {country}
                                                                    </>
                                                                }))
                                                            }
                                                            defaultValue={
                                                                this.state.country
                                                            }
                                                            onChange={(e, data) => {
                                                                window.location.href = `/ooh/${data.value.toLowerCase()}`
                                                            }}
                                                        />
                                                </Grid.Row>
                                        </Header>
                                    </Responsive>
                                </div>
                                <div className="col-4" style={{display: 'flex', justifyContent:'flex-end', alignContent:'center'}}>
                                    
                                    <LangButton />

                                    <Grid.Column width={1}>
                                        <Button id='btn_form_wa_active_menu' circular color='green' icon='whatsapp' className="btn_form_wa_active" onClick={(e) => this.handleWhatsApp(e)}/>
                                    </Grid.Column>

                                    <Responsive minWidth={500} style={{paddingBottom: '1.5em'}}>
                                        <Grid.Column width={1}>
                                            <Button animated='vertical' circular color="orange" onClick={this.showFavotires}>
                                                <ButtonContent hidden>{this.props.media.favoriteMediaList.length}</ButtonContent>
                                                <ButtonContent visible>
                                                    <Icon name='shop' />
                                                </ButtonContent>
                                            </Button>
                                        </Grid.Column>
                                    </Responsive>

                                    {/* mobile help button */}
                                    <Responsive maxWidth={499} style={{paddingBottom: '1.5em'}}>
                                        {!this.state.visible ? <HelpModal /> : <></>}
                                    </Responsive>

                                    {/* destop help button */}
                                    <Responsive minWidth={500} style={{paddingBottom: '1.5em'}}>
                                        <HelpModal />
                                    </Responsive>

                                    <Responsive maxWidth={499} style={{paddingBottom: '1.5em'}}>
                                        <Button
                                            hidden={this.state.visible}
                                            circular
                                            size="tiny"
                                            color="orange"
                                            onClick={this.showFavotires}
                                            icon="shopping cart"
                                            labelPosition='right'
                                            content={`${this.props.media.favoriteMediaList.length}`}
                                        />
                                    </Responsive>
                                    <br/>
                                </div>
                            </Grid.Row>
                            <Responsive maxWidth={499}
                                style={{paddingBottom:'0.5em', paddingTop: '0.5em', width: '100%', display: 'flex', justifyContent: 'center'}}
                            >
                                <Grid.Row style={{display: `${!this.state.visible ? 'flex' : 'none'}`, justifyContent: 'center', width: '100%', flexDirection: 'column'}}>
                                    {/* new code  */}
                                    <Grid.Row style={{display: 'flex', justifyContent: 'center'}}>
                                        <Header style={{margin: 0}} as="h5" inverted>
                                            {t("main.find_your_country")}
                                        </Header>
                                    </Grid.Row>
                                    <Grid.Row style={{display: 'flex', justifyContent: 'center', marginLeft: '5px', marginRight: '5px',}}>
                                        <Select
                                            fluid={true}
                                            placeholder={t("main.select_your_country")}
                                            style={{
                                                textAlign: 'center'
                                            }}
                                            options={
                                                Object.entries(countries).map(([index, country]) => ({
                                                    key: index.toLowerCase(),
                                                    value: index.toLowerCase(),
                                                    text: <>
                                                        <ReactCountryFlag
                                                            hidden={this.state.visible}
                                                            onClick={() => window.location.href = `/${index.toLowerCase()}/ooh/`}
                                                            countryCode={index}
                                                            svg
                                                            title={country}
                                                            style={{
                                                                paddingLeft: '5px', paddingRight: '5px', fontSize: '2.5em', cursor: 'pointer'
                                                            }}
                                                        />
                                                        {country}
                                                    </>
                                                }))
                                            }
                                            defaultValue={
                                                this.state.country
                                            }
                                            onChange={(e, data) => {
                                                window.location.href = `/ooh/${data.value.toLowerCase()}/`
                                            }}
                                        />
                                    </Grid.Row>
                                    {/* <Grid.Row style={{display: 'flex', justifyContent: 'center'}}>
                                        <Header style={{margin: 0}} as="h5" inverted>
                                            Localiza tu país
                                        </Header>
                                    </Grid.Row>
                                    <Grid.Row style={{display: 'flex', justifyContent: 'center'}}>
                                        {
                                            Object.keys(country_settings).map( key => (
                                                <ReactCountryFlag
                                                    hidden={this.state.visible}
                                                    onClick={() => window.location.href = `/${key.toLowerCase()}/ooh/`}
                                                    countryCode={key}
                                                    svg
                                                    title={key}
                                                    style={{paddingLeft: '5px', paddingRight: '5px', fontSize: '2.5em', cursor: 'pointer' }}
                                                />
                                            ))
                                        }
                                    </Grid.Row> */}
                                </Grid.Row>
                            </Responsive>
                            <Grid.Row>
                                <Grid.Column width={16} style={{display: "flex"}}>
                                    <MapContainer countryHasSettings={this.countryHasSettings} setCountry={this.setCountry} country={this.state.country} />
                                    <FavoriteModal />
                                    <ContactModal />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid>
                            </Grid>
                        </Segment>
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
                </Ref>
            </div>
            </>
        )
    }
}

const mapStateToProps = (state) => ({ media: state.media })

export default connect(mapStateToProps)(withTranslation()(Main))